import React from 'react';
import classNames from 'classnames';
import cls from './FinancialIndicatorsBlockHeader.module.css';
import { useFinancialIndicatorsBlockHeader } from './useFinancialIndicatorsBlockHeader';
import { FinancialIndicatorsBlockInfo } from '../FinancialIndicatorsBlockInfo/FinancialIndicatorsBlockInfo';

interface FinancialIndicatorsBlockHeaderProps {
    classes?: string;
}

export const FinancialIndicatorsBlockHeader = ({
    classes,
}: FinancialIndicatorsBlockHeaderProps) => {
    const {} = useFinancialIndicatorsBlockHeader();
    return (
        <div className={classNames(cls.FinancialIndicatorsBlockHeader, [classes])}>
            <span className={cls.FinancialIndicatorsBlockTitle}>
                {i18next.t('FinancialIndicatorsBlockHeader.result.financialIndicatorsBlockTitle')}
            </span>
            <FinancialIndicatorsBlockInfo />
        </div>
    );
};
